module.exports = __webpack_public_path__ + "static/img/6@2x.38963659.png";